
/* styles */
require("!!./../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../vue-loader/lib/style-rewriter?id=data-v-4251a22f!./../../vue-loader/lib/selector?type=styles&index=0!./Icon.vue")

var Component = require("!./../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../vue-loader/lib/selector?type=script&index=0!./Icon.vue"),
  /* template */
  require("!!./../../vue-loader/lib/template-compiler?id=data-v-4251a22f!./../../vue-loader/lib/selector?type=template&index=0!./Icon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/components/Icon.vue
// module id = 9
// module chunks = 1